/**
 * CMSD Version 1
 *
 * @public
 */
export const CMSD_V1 = 1
